import { createAction } from "redux-actions";
import { CHANGE_AB_TEST_VERSION_ACTION, RUN_AB_TEST_ACTION } from "./constants";

/**
 * Action to run AB test
 */
export const runAbTest = createAction(RUN_AB_TEST_ACTION);

/**
 * Action to set AB test version
 */
export const changeAbTestVersion = createAction(CHANGE_AB_TEST_VERSION_ACTION);
